/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Hatchery } from '../../models/hatchery';

export interface SetActiveHatchery$Params {
  hatcheryId: number;
  isActive: boolean;
}

export function setActiveHatchery(http: HttpClient, rootUrl: string, params: SetActiveHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<Hatchery>> {
  const rb = new RequestBuilder(rootUrl, setActiveHatchery.PATH, 'put');
  if (params) {
    rb.path('hatcheryId', params.hatcheryId, {});
    rb.path('isActive', params.isActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Hatchery>;
    })
  );
}

setActiveHatchery.PATH = '/api/hatchery/{hatcheryId}/setActive={isActive}';
